var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VCard", {
    attrs: {
      avartar: _vm.sportIcon,
      title: _vm.field.name,
      "cover-photo-url": _vm.field.coverPhotoUrl,
      description: _vm.field.description ? _vm.field.description : "-",
      "enable-delete": true
    },
    on: { delete: _vm.deleteField },
    scopedSlots: _vm._u(
      [
        _vm._l(_vm.$slots, function(index, name) {
          return {
            key: name,
            fn: function() {
              return [_vm._t(name)]
            },
            proxy: true
          }
        })
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }